import React from 'react'
import { Link } from 'react-router-dom'
import s from '../css/auth.module.css'
import Loader from './Loader'

const ForgotPassword = ({
	handleSubmit,
	handleChange,
	values,
	errors,
	disabled,
	status,
}) => {
	return (
		<div className={s.container}>
			<div className='common__body'>
				<h3>Восстановление пароля</h3>

				{status.message === 'ok' ? (
					<p className={s.hint}>
						Если аккаунт существует, мы отправили письмо со ссылкой для сброса
						пароля
					</p>
				) : (
					<form action='' onSubmit={e => handleSubmit(e)}>
						<p className={s.hint}>
							Укажите почту, с которой вы регистрировались
						</p>

						<div className={s.input}>
							<input
								type='email'
								placeholder='Электронная почта'
								autoComplete='off'
								onChange={e => handleChange(e)}
								defaultValue={values.email}
								name='email'
								id='email'
							/>
							{errors.email && <label htmlFor='email'>{errors.email} </label>}
						</div>

						<div className={s.btn}>
							<button id='btn' disabled={disabled || status.isLoading}>
								{status.isLoading ? (
									<Loader isButton={true} />
								) : (
									'Отправить ссылку'
								)}
							</button>

							{status.message && status.message !== 'ok' && (
								<label htmlFor='btn'>{status.message}</label>
							)}
						</div>
					</form>
				)}

				<div className={s.links}>
					<Link to='/signin'>Вернуться ко входу</Link>
				</div>
			</div>
		</div>
	)
}

export default ForgotPassword
